// extracted by mini-css-extract-plugin
export default {"calnder_container":"slider_calnder_container__JbAtb","calnder":"slider_calnder__v5h3H"};